import { render } from "./CompSectionPriceSheetComponent.vue?vue&type=template&id=3e9c04fb&scoped=true"
import script from "./CompSectionPriceSheetComponent.vue?vue&type=script&lang=js"
export * from "./CompSectionPriceSheetComponent.vue?vue&type=script&lang=js"

import "./CompSectionPriceSheetComponent.vue?vue&type=style&index=0&id=3e9c04fb&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9c04fb"]])

export default __exports__